export enum SeverityFilter {
  Normal,
  Highlighted,
  Event,
}

export enum SeverityLevel {
  Normal,
  Highlighted,
  Event,
}

export enum NotificationType {
  CompanyNotice,
  Survey,
  VirtualClassroom,
  SimulatorTraining,
}

export enum EventRoles {
  None,
  Listener,
  Presenter,
  Host,
}

export type NotificationItem = {
  id: Guid
  resultId: Nullable<Guid>
  severity: SeverityLevel
  dateCreated: string
  deadline: Nullable<string>
  name: string
  type: NotificationType
  parentEntityId: Guid
}

export type EventNotificationItem = NotificationItem & {
  eventRole: EventRoles
  timeZoneId: TimeZone
}

export type NotificationsResponse = {
  userNotifications: NotificationItem[]
}
